import React from 'react';
import PublicProfile, {
  getServerSideProps as publicProfileGetServerSideProps,
} from './index';
const PublicProfileWithAlias = (props) => {
  return <PublicProfile {...props} />;
};

export default PublicProfileWithAlias;

export async function getServerSideProps(ctx) {
  return publicProfileGetServerSideProps(ctx);
}
